export const getMonthNow = () => new Date().getMonth();
